import styled from 'styled-components';

export const StyledPage = styled.div<{ noPadding?: boolean }>`
  clear: both;
  padding: ${({ noPadding }) => (noPadding ? 0 : '32px 0')};
`;
